<template>
<div class="p-fluid">
    <div class="p-col-12 p-lg-12">
<div class="card card-w-title">
  <div class="p-formgrid">
    <div class="group-permission-title p-grid">
      <div v-if="this.mode == 'add'">Thêm quản lý - tài khoản tòa</div>
      <div v-else>Chỉnh sửa quản lý - tài khoản tòa</div>
      <Toolbar class="fixed-bottom-toolbar" style="flex: auto;">
      <template slot="right">
        <Button
          label="Quay lại"
          @click="backToList()"
          class="p-button-warning"
        />
        <Button
          v-if="mode == 'edit'"
          :label="'Lưu thay đổi'"
          @click="saveData()"
          class="p-button-success"
        />
        <Button
          v-else
          :label="'Thêm mới'"
          @click="saveData()"
          class="p-button-success"
        />
      </template>
    </Toolbar>
    </div>
      <div class="card card-w-body">
        <div class="p-field p-grid" style="padding-top: 15px;">
<!--          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Ảnh đại diện(*)</label>
            <div class="p-col-8">
              <FileUpload
                name="avatar"
                @select="onFileSelect($event)"
                mode="basic"
                chooseLabel="Chọn ảnh đại diện"
              >
              </FileUpload>
              <img
                :src="this.avatar_img"
                style="padding:10px; max-height:200px"
              />
            </div>
          </div>-->
          <div class="p-col-2">
          </div>
<!--          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Nhóm quyền (*)</label>
            <div class="p-col-8">
              <Dropdown id="group_permission_id" :showClear="true" :filter="true"
              v-model="group_permission_id" :options="list_group_permission" optionLabel="name"
              placeholder="Chọn nhóm quyền"/>
              <small
                v-if="validationErrors && validationErrors['group_permission_id']"
                class="p-invalid"
              >{{validationErrors['group_permission_id']}}</small>
            </div>
          </div>-->
        </div>
        <div class="p-field p-grid">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Mã tài khoản(*)</label>
            <div class="p-col-8">
              <InputText v-model="code"  id="code" type="text" class="p-col-width" placeholder="Nhập mã tài khoản" />
              <small
                v-if="validationErrors && validationErrors['code']"
                class="p-invalid"
              >{{validationErrors['code']}}</small>
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Mã tòa</label>
            <div class="p-col-8 style-multilselect">
              <MultiSelect style="width: 100%" id="area_id" :showClear="true" :filter="true"
              v-model="selectedAgency" :options="listCodeAgency" optionLabel="title" optionValue="code"
              placeholder="Chọn"/>
              <!-- <small
                v-if="validationErrors && validationErrors['area_id']"
                class="p-invalid"
              >{{validationErrors['area_id']}}</small> -->
            </div>
          </div>
        </div>
        <div class="p-field p-grid">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Tên tài khoản(*)</label>
            <div class="p-col-8">
              <InputText v-model="fullname"  id="fullname" type="text" class="p-col-width" placeholder="Nhập tên tài khoản" />
              <small
                v-if="validationErrors && validationErrors['fullname']"
                class="p-invalid"
              >{{validationErrors['fullname']}}</small>
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Mật khẩu (*)</label>
            <div class="p-col-8">
              <InputText v-model="password" :type="passwordType" placeholder="Nhập mật khẩu"></InputText>
              <i v-if="passwordType == 'text'" class="pi pi-eye" @click="switchVisibility" 
              style="position: absolute;margin-left: -30px;margin-top: 10px;"/>
              <i v-else class="pi pi-eye-slash" @click="switchVisibility"
              style="position: absolute;margin-left: -30px;margin-top: 10px;"/>
              <small
                v-if="validationErrors && validationErrors['password']"
                class="p-invalid"
              >{{validationErrors['password']}}</small>
            </div>
          </div>
        </div>
        <div class="p-field p-grid" style="padding-top: 10px;">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Email(*)</label>
            <div class="p-col-8">
              <InputText v-model="email"  :disabled="mode == 'edit'" id="email" type="text" class="p-col-width" placeholder="Nhập email" />
              <small
                  v-if="validationErrors && validationErrors['email']"
                  class="p-invalid"
              >{{validationErrors['email']}}</small>
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Trạng thái</label>
            <div class="p-col-8">
              <Checkbox v-model="active" :binary="true" /> Kích hoạt
            </div>
          </div>
        </div>
<!--        <div class="p-field p-grid" style="padding-top: 10px;">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Ngày vào làm việc</label>
            <div class="p-col-8">
              <Calendar v-model="join_date" dateFormat="dd/mm/yy" placeholder="Chọn ngày vào làm việc" :showIcon="true"/>    
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
          </div>
        </div>-->
<!--        <div class="p-field p-grid" style="padding-top: 10px;">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Địa chỉ</label>
            <div class="p-col-8">
              <InputText v-model="address"  id="address" type="text" class="p-col-width" placeholder="Nhập địa chỉ" />    
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
          </div>
        </div>-->
<!--        <div class="p-field p-grid" style="padding-top: 10px;">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Số điện thoại</label>
            <div class="p-col-8">
              <InputText v-model="phone"  id="phone" type="text" class="p-col-width" placeholder="Nhập số điện thoại" />    
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
          </div>
        </div>
        <div class="p-field p-grid" style="padding-top: 10px;">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Email(*)</label>
            <div class="p-col-8">
              <InputText v-model="email"  :disabled="mode == 'edit'" id="email" type="text" class="p-col-width" placeholder="Nhập email" />
              <small
                v-if="validationErrors && validationErrors['email']"
                class="p-invalid"
              >{{validationErrors['email']}}</small>
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
          </div>
        </div>-->
      </div>
  </div>
</div>
    </div>
</div>
</template>

<script>
import DataServices from '@/core/DataServices'
import Config from '../../../config/index'
//import moment from "moment-timezone";
import gql from "graphql-tag";
//import graphql from "@/views/admin/common/graphql";
export default {
  props: {
    mode: String,
    model: Object,
  },
  data() {
    return {
      validationErrors: {},
      formMode: this.mode,
      list_group_permission: [],
      listCodeAgency: [],
      group_permission_id: null,
      selectedAgency: null,
      avatar_img: '',
      list_area: [],
      area_id: null,
      code: '',
      password: '',
      fullname: '',
      passwordType: 'password',
      birthday: '',
      active: false,
      join_date: '',
      address: '',
      phone: '',
      email: '',
      list_user_dpv: [],
      users_account_id: ''
    }
  },
  async mounted() {
    if (this.$route.params.id !== undefined) {
      this.user_dpv_id = this.$route.params.id
    }
    // console.log('this.group_permission_id', this.group_permission_id)
    var where = {deleted: {_eq: false}};
    var order_by = {created_at : 'desc'};
     this.$CoreService.getListData('office_agency', where,null,null,order_by).then(res => {
      console.log("resresres:",res)
      var list_data = [];
      if (res){
        var data_afency = res.office_agency;
        for (var i=0;i<data_afency.length;i++){
          // console.log("res[i].code:",res[i].code)
          var item_res = data_afency[i];
          item_res.title = `[${data_afency[i].code}] ${data_afency[i].name}`;
          //res[i].title = `[${res[i].code}] ${res[i].name}`;
          list_data.push(item_res);
        }
      }
      this.listCodeAgency = list_data;
    });
  },
  methods: {
    switchVisibility() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    async onFileSelect(event) {
      var s3client = Config.s3Client();
      console.log("Upload event", event);
      for (let i = 0; i < event.files.length; i++) {
        const f = event.files[i];
        console.log("Files", f);
        
        // let fileName1 = f.name
        // let idxDot = fileName1.lastIndexOf(".") + 1;
        // let extFile = fileName1.substr(idxDot, fileName1.length).toLowerCase();
        // if ((extFile != "jpg" && extFile != "jpeg" && extFile != "png") & col.accessable == 'image/jpeg') {
        //   alert("Vui lòng chọn file jpg/jpeg hoặc png!");
        //   return
        // }

        // let fileName = f.name.split('.')[0].replace(/ /g, '')
        let fileName = Math.random().toString().slice(2)
        // console.log('filename',fileName)
        let random = Math.random().toString().slice(2)
        fileName = `${random}_${fileName}`
        s3client.uploadFile(f, fileName).then((data) => {
          console.log(data.location);
          this.avatar_img = data.location;
          //this.$forceUpdate();
        });
      }
      var that = this
      setTimeout(function () {
        // that.$store.commit("setLoading", false);
        console.log('return image', that.value)
      }, 3000)
        
      //console.log("Result", this.value[col.name]);
    },
    backToList() {
      this.$emit('back');
    },
    async validateData() {
      //console.log("selectedAgencyselectedAgency:",this.selectedAgency)
      console.log('-------------------------------')
      this.validationErrors = {};
      var that = this;
      var has_error = false
      if (this.fullname === '') {
        this.validationErrors['fullname'] = 'Vui lòng nhập tên tài khoản';
        has_error = true
        this.$forceUpdate() 
      }
      if (this.code === '') {
        this.validationErrors['code'] = 'Vui lòng nhập mã tài khoản';
        has_error = true
        this.$forceUpdate() 
      } else {
        if (this.mode == 'add') {
          let query = `query MyQuery($code: String) {
            users(where: {code: {_like: $code}, deleted: {_eq: false}}) {
              id
            }
          }`
          await this.$apollo
            .query({
              query: gql(query),
              variables: {
                code: this.code
              }
            })
            .then(async (res) => {
              console.log('res', res)
              if (res.data.users[0]) {
                console.log('0000000000000000000000')
                this.validationErrors['code'] = 'Mã tài khoản bị trùng';
                has_error = true
                this.$forceUpdate() 
              }
            })
        } else {
          let query = `query MyQuery($code: String, $id: uuid) {
            users(where: {code: {_like: $code}, deleted: {_eq: false}, id: {_neq: $id}}) {
              id
            }
          }`
          await this.$apollo
            .query({
              query: gql(query),
              variables: {
                code: this.code,
                id: this.$route.params.id
              }
            })
            .then(async (res) => {
              console.log('res', res)
              if (res.data.users[0]) {
                console.log('0000000000000000000000')
                this.validationErrors['code'] = 'Mã tài khoản bị trùng';
                has_error = true
                this.$forceUpdate() 
              }
            }) 
        }
      }
      if (this.email === '') {
        this.validationErrors['email'] = 'Vui lòng nhập email';
        has_error = true
        this.$forceUpdate() 
      } else {
        var whereEmailExist = {account: {_eq: this.email}, deleted: {_eq: false}};
        if (this.mode != 'add') {
          whereEmailExist.uid = {_neq: this.$route.params.id};
        }
        var checkEmailExist =await that.$CoreService.getObjectData('accounts',whereEmailExist);

        if (checkEmailExist){
          this.validationErrors['email'] = 'Email này đã tồn tại';
          has_error = true
          this.$forceUpdate()
        }

        /*if (this.mode == 'add') {
          let query = `query MyQuery($email: String) {
            users(where: {email: {_like: $email}, deleted: {_eq: false}}) {
              id
            }
          }`
          await this.$apollo
            .query({
              query: gql(query),
              variables: {
                email: this.email
              }
            })
            .then(async (res) => {
              if (res.data.users.length > 0) {
                this.validationErrors['email'] = 'Email đã có người sử dụng';
                has_error = true 
                this.$forceUpdate() 
              }
            })
        } else {
          let query = `query MyQuery($email: String, $id: uuid) {
            users(where: {email: {_like: $email}, deleted: {_eq: false}, id: {_neq: $id}}) {
              id
            }
          }`
          await this.$apollo
            .query({
              query: gql(query),
              variables: {
                email: this.email,
                id: this.$route.params.id
              }
            })
            .then(async (res) => {
              console.log('res', res)
              if (res.data.users[0]) {
                console.log('0000000000000000000000')
                this.validationErrors['email'] = 'Email đã có người sử dụng';
                has_error = true
                this.$forceUpdate() 
              }
            }) 
        }*/
      }
      /*if (this.group_permission_id == null) {
        this.validationErrors['group_permission_id'] = 'Vui lòng chọn nhóm quyền';
        has_error = true
        this.$forceUpdate() 
      }*/
      if (this.mode == 'add') {
        if (this.password === '') {
          this.validationErrors['password'] = 'Vui lòng nhập mật khẩu';
          has_error = true
          this.$forceUpdate() 
        }  
      }
      return has_error
    },
    async analyzeData() {
      //console.log('dâdadadadadadad')
      var data_user_dpv = {}
        data_user_dpv['fullname'] = this.fullname
        data_user_dpv['code'] = this.code
        //data_user_dpv['group_permission_id'] = this.group_permission_id.id
        //data_user_dpv['avatar'] = this.avatar_img
       // data_user_dpv['area_id'] = this.area_id.id
       // data_user_dpv['address'] = this.address
        if (this.selectedAgency){
          data_user_dpv["str_code_agency"] = this.selectedAgency.join(',')
        }
        //Lấy nhóm quyền cho tòa
        var where_group_permission = {type: {_eq: 1}};
        var obj_group_permission = await this.$CoreService.getObjectData('group_permission', where_group_permission);
        if (!this.$commonFuction.isEmpty(obj_group_permission)){
          data_user_dpv['group_permission_id'] = obj_group_permission.id
        }
        data_user_dpv['active'] = this.active
        //data_user_dpv['phone'] = this.phone
        data_user_dpv['email'] = this.email
        //data_user_dpv['join_date'] = (!this.$commonFuction.isEmpty(this.join_date)) ? moment(this.join_date).add(1, 'days') : null
        //data_user_dpv['birthday'] = (!this.$commonFuction.isEmpty(this.birthday)) ? moment(this.birthday).add(1, 'days'): null
        console.log('sfdsdsd', data_user_dpv)
      return data_user_dpv
    },
    async analyzeDataEdit() {
      var data_user_dpv = {}
        data_user_dpv['fullname'] = this.fullname
        data_user_dpv['code'] = this.code
        //data_user_dpv['group_permission_id'] = this.group_permission_id.id
        //data_user_dpv['avatar'] = this.avatar_img
        //data_user_dpv['area_id'] = this.area_id.id
        //data_user_dpv['address'] = this.address
        if (this.selectedAgency){
          data_user_dpv["str_code_agency"] = this.selectedAgency.join(',')
        }
        data_user_dpv['active'] = this.active
        //data_user_dpv['phone'] = this.phone
        data_user_dpv['email'] = this.email
        //data_user_dpv['join_date'] = (!this.$commonFuction.isEmpty(this.join_date)) ? moment(this.join_date).add(1, 'days') : null
        //data_user_dpv['birthday'] = (!this.$commonFuction.isEmpty(this.birthday)) ? moment(this.birthday).add(1, 'days'): null

      console.log('sfdsdsd', data_user_dpv)
      return data_user_dpv
    },
    async saveData() {
      if (await this.validateData()) {
        // console.log('true')
        return;
      }
      console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxx');
      var that = this;
      if (this.mode == 'add') {
        // this.$store.commit("setLoading", true);

        var data_user_dpv = await this.analyzeData()

        let queryCreteUser = `mutation MyMutation {
                createUser(email: "${this.email}", fullname: "${this.fullname}", password: "${this.password}") {
                  uid
                }
              }`;
        await this.$apollo.mutate({
          mutation: gql(queryCreteUser)
        }).then(async (res) => {
          var firebaseID = res.data.createUser.uid;
          if (firebaseID) {
            var dataInsert = this.$commonFuction.convertJsonObject(data_user_dpv);
            let insertDataAccount = {
              'id': firebaseID,
              //'uid': returning.id,
              'account': this.email,
              'type': 'EMAIL',
              'role': 'court'
            }
            dataInsert.users_account = {data: this.$commonFuction.convertJsonObject(insertDataAccount)};
            await that.$apollo
                .mutate({
                  //mutation: gql(queryUsers),
                  mutation: DataServices.insertData('users'),
                  variables: {
                    objects: dataInsert
                  }
                })
                .then(async (resUser)  => {
                  console.log("resUserresUserresUserresUser:",resUser);
                  console.log("resUser.data[Object.keys(res.data)[0]]:",resUser.data.insert_users.returning[0].id);
                  if (resUser.data.insert_users.returning[0].id) {
                    var idUser = resUser.data.insert_users.returning[0].id;
                    let update_variables = {
                      'data_update': {
                        'role': 'court'
                      },
                      'where_key': {
                        'uid': {'_eq': idUser}
                      }
                    };
                    await that.$apollo.mutate({
                      mutation: DataServices.updateData('accounts'),
                      variables: update_variables
                    }).then(() => {
                     /* that.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Tạo tài khoản thành công', life: 3000 })
                      setTimeout(function () {
                        // that.$store.commit("setLoading", false);
                        //  location.href = '/admin/list-users_dpv'
                      }, 3000)*/
                    }).catch((error) => {
                      that.$toast.add({ severity: 'error', summary: 'Thất bại', detail: 'Tạo dữ liệu gặp vấn đề', life: 3000 })
                      console.error('ERROR: ', error)
                    })
                  }


                  /*let update_variables = {
                    'data_update': {
                      'role': 'dpv'
                    },
                    'where_key': {
                      'id': {'_eq': firebaseID}
                    }
                  };
                  await this.$apollo.mutate({
                    mutation: DataServices.updateData('accounts'),
                    variables: update_variables
                  }).then(() => {
                    this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Tạo tài khoản thành công', life: 3000 })
                    setTimeout(function () {
                      // that.$store.commit("setLoading", false);
                    //  location.href = '/admin/list-users_dpv'
                    }, 3000)
                  }).catch((error) => {
                    this.$toast.add({ severity: 'error', summary: 'Thất bại', detail: 'Tạo dữ liệu gặp vấn đề', life: 3000 })
                    console.error('ERROR: ', error)
                  })*/

                  that.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Tạo tài khoản thành công', life: 3000 })
                  setTimeout(function () {
                    // that.$store.commit("setLoading", false);
                    location.href = '/admin/list-court_account'
                  }, 100);

                }).catch(async error => {
                  this.$toast.add({ severity: 'error', summary: 'Thất bại', detail: 'Tạo dữ liệu gặp vấn đề', life: 3000 })
                  console.error('ERROR: ', error)
                });
          }
        })

        /*var query = `mutation MyMutation($objects: [users_insert_input!]!) {
            insert_users(objects: $objects) {
              affected_rows
              returning {
                id
              }
            }
          }`;
        console.log("query", query);
        await this.$apollo
          .mutate({
            mutation: gql(query),
            variables: {
              objects: [data_user_dpv]
            }
          })
          .then(async (res) => {
            if (res.data[Object.keys(res.data)[0]].affected_rows > 0) {
              var returning = res.data[Object.keys(res.data)].returning[0];
              // await this.uploadImages(returning.id);
              // TRIGGER HASURA TO CALL FIREBASE FUNCTION CREATE USER
              let query = `mutation MyMutation {
                createUser(email: "${this.email}", fullname: "${this.fullname}", password: "${this.password}") {
                  uid
                }
              }`;
              await this.$apollo.mutate({
                mutation: gql(query)
              }).then(async (res) => {
                // console.log('=========> createUser: ', res)
                var firebaseID = res.data.createUser.uid;
                if (firebaseID) {
                  let insertData = {
                    'id': firebaseID,
                    'uid': returning.id,
                    'account': this.email,
                    'type': 'EMAIL',
                    'role': 'dpv'
                  }
                  await this.$apollo.mutate({
                    mutation: DataServices.insertData('accounts'),
                    variables: {
                      'objects': insertData
                    }
                  }).then(async () => {
                    // console.log('TAO THANH CONG ACCOUNT', firebaseID)
                    let update_variables = {
                      'data_update': {
                        'role': 'dpv'
                      },
                      'where_key': {
                        'id': {'_eq': firebaseID}
                      }
                    };
                    await this.$apollo.mutate({
                      mutation: DataServices.updateData('accounts'),
                      variables: update_variables
                    }).then(() => {
                      this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Tạo tài khoản thành công', life: 3000 })
                      setTimeout(function () {
                        // that.$store.commit("setLoading", false);
                        location.href = '/admin/list-users_dpv'
                      }, 3000)
                    }).catch((error) => {
                      this.$toast.add({ severity: 'error', summary: 'Thất bại', detail: 'Tạo dữ liệu gặp vấn đề', life: 3000 })
                      console.error('ERROR: ', error)
                    })
                  }).catch((error) => {
                    this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Tạo dữ liệu gặp vấn đề', life: 3000 })
                    console.error('ERROR: ', error)
                  })
                }
              })
            } else {
              // this.$store.commit("setLoading", false);
              this.$toast.add({
                severity: "error",
                summary: "Thất bại",
                detail: "Lưu dữ liệu thất bại",
                life: 3000
              });
            }
          })*/
      } else {
        let data_user_dpv_update = await this.analyzeDataEdit();
        delete data_user_dpv_update.email;//ko update email
        // let group_permission_id = await this.getGroupPerId()
        let query = `mutation MyMutation($users_id: uuid!, $users_update: users_set_input) {
          update_users(where: {id: {_eq: $users_id}}, _set: $users_update) {
            affected_rows
            returning {
              id
              fullname
            }
          }
        }`;

        await this.$apollo
          .mutate({
            mutation: gql(query),
            variables: {
              users_id: this.user_dpv_id,
              users_update: data_user_dpv_update,
            }
          })
          .then(async (res) => {
            if (res.data[Object.keys(res.data)[0]].affected_rows > 0) {
              if (this.password !== '') {
                console.log('-----------------',this.password,this.users_account_id)
                let query = `mutation MyMutation {
                  changePassword(password: "${this.password}", uid: "${this.users_account_id}") {
                    uid
                  }
                }`;
                await this.$apollo.mutate({
                  mutation: gql(query)
                }).then(() => {
                  this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Cập nhật thành công', life: 3000 })
                  setTimeout(function () {
                    // that.$store.commit("setLoading", false);
                    location.href = '/admin/list-users_dpv'
                  }, 100)
                }).catch((error) => {
                  this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Cập nhật gặp vấn đề', life: 3000 })
                  console.error('ERROR: ', error)
                })
              } else {
                this.$toast.add({
                  severity: "success",
                  summary: "Thành công",
                  detail: "Cập nhật thành công",
                  life: 4000
                });
                console.log('res',res)
                this.displayDialog = false;
                setTimeout(function () {
                  // that.$store.commit("setLoading", false);
                  location.href = '/admin/list-court_account'
                }, 3000)
              }
            } else {
              // this.$store.commit("setLoading", false);
              this.$toast.add({
                severity: "error",
                summary: "Thất bại",
                detail: "Cập nhật gặp vấn đề",
                life: 3000
              });
            }
          })
      }
    },
  },
  apollo: {
    group_permission: {
      query() {
        let query = `
          query MyQuery {
            group_permission {
              id
              name
            }
          }
        `
        return gql(query);
      },
      update(data) {
        if(data.group_permission){
          this.list_group_permission = data.group_permission
        }
      },
      fetchPolicy: "network-only"
    },
    /*area: {
      query() {
        let query = graphql.GET_AREA_COMMON
        return gql(query);
      },
      update(data) {
        if(data.area){
          this.list_area = data.area
        }
      },
      fetchPolicy: "network-only"
    },*/
    user_dpv: {
      query() {
        let query = `
          query MyQuery($id: uuid) {
            users(where: {id: {_eq: $id}}) {
              avatar
              fullname
              phone
              email
              birthday
              code
              address
              active
              join_date
              str_code_agency
              group_permissions {
                id
                name
              }
              areas {
                id
                code
              }
              users_account {
                id
              }
            }
          }
        `
        return gql(query);
      },
      variables() {
        return {
					id: this.$route.params.id
				}
      },
      update(data) {
        if(data.users){
          this.list_user_dpv = data.users
          this.fullname = this.list_user_dpv[0].fullname
          //this.birthday = (this.list_user_dpv[0].birthday) ? (new Date(this.list_user_dpv[0].birthday)):'';
          //this.join_date = (this.list_user_dpv[0].join_date) ? (new Date(this.list_user_dpv[0].join_date)):'';
          //this.avatar_img = this.list_user_dpv[0].avatar
          //this.phone = this.list_user_dpv[0].phone
          this.email = this.list_user_dpv[0].email
          this.code = this.list_user_dpv[0].code
          //this.address = this.list_user_dpv[0].address
          this.active = this.list_user_dpv[0].active
          //this.group_permission_id = this.list_user_dpv[0].group_permissions
          //this.area_id = this.list_user_dpv[0].areas
          this.users_account_id = this.list_user_dpv[0].users_account[0].id
          console.log("this.list_user_dpv[0].str_code_agency:",this.list_user_dpv[0].str_code_agency)
          if (!this.$commonFuction.isEmpty(this.list_user_dpv[0].str_code_agency)){
            this.selectedAgency = this.list_user_dpv[0].str_code_agency.split(',')
          }

          console.log('--------------------', this.users_account_id)
        }
      },
      fetchPolicy: "network-only",
      skip() {
        return !this.$route.params.id
      }
    },
  }
}
</script>

<style lang="scss">
  .p-multiselect {
    width: 450px;
  }
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: .25rem;
    padding-bottom: .25rem;
    
  }
  .category-item-value {
    padding: .25rem .5rem;
    border-radius: 3px;
    display: inline-flex;
    margin-right: .2rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
  .p-multiselect-label-container{
    height: 40px;
  }
  .card.card-w-body {
    background-color: #FAFAFA;
    // padding: 1em;
    margin-bottom: 20px;
    margin-top: 20px;
  }
  
  </style>
